(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-engine-builder]').forEach(builder => {
      if (builder.dataset.initialized) return;
      builder.dataset.initialized = 'true';
      const content = builder.querySelector('[data-engine-content]');
      const formatter = new Intl.NumberFormat(builder.dataset.locale || 'sv-SE', {style:'currency',currency:builder.dataset.currency || 'SEK',maximumFractionDigits:2,minimumFractionDigits:0});
      function update() {
        const form = content.querySelector('[data-engine-form]');
        if (!form) return;
        const selected = form.querySelector('[data-engine-accessory]').checked;
        form.querySelector('[data-engine-includes]').textContent = selected ? builder.dataset.includedText : builder.dataset.excludedText;
        const details = form.querySelector('[data-engine-details]');
        const detailsUrl = new URL(details.href); detailsUrl.searchParams.set('tillbehor', selected ? '1' : '0'); details.href = detailsUrl.href;
        const pageUrl = new URL(location.href); pageUrl.searchParams.set('tillbehor', selected ? '1' : '0'); history.replaceState(null, '', pageUrl);
        const total = Number(form.dataset.enginePrice) + (selected ? Number(form.dataset.accessoryPrice) : 0);
        const available = form.dataset.engineAvailable === 'true' && (!selected || form.dataset.accessoryAvailable === 'true');
        form.querySelectorAll('[data-accessory-input]').forEach(input => input.disabled = !selected);
        form.querySelector('[data-accessory-summary]').hidden = !selected;
        form.querySelector('[data-engine-total]').textContent = formatter.format(total / 100);
        form.querySelector('[data-engine-submit]').disabled = !available;
        form.querySelector('[data-engine-stock]').textContent = form.dataset.engineStockText;
        const accessoryStock = form.querySelector('[data-engine-accessory-stock]');
        if (accessoryStock) accessoryStock.hidden = !selected;
        const error = form.querySelector('[data-engine-error]');
        error.hidden = true;
        error.textContent = '';
      }
      builder.addEventListener('change', event => {
        if (event.target.matches('[data-engine-class]')) {
          const template = [...builder.querySelectorAll('[data-engine-template]')].find(template => template.dataset.engineTemplate === event.target.value);
          if (!template) return;
          const previous = content.querySelector('[data-engine-accessory]')?.checked;
          content.replaceChildren(template.content.cloneNode(true));
          const choice = content.querySelector('[data-engine-accessory]');
          if (!choice.disabled && previous !== undefined) choice.checked = previous;
          const url = new URL(window.location.href);
          url.searchParams.set('klass', event.target.value);
          window.history.replaceState(null, '', url);
          update();
        } else if (event.target.matches('[data-engine-accessory]')) update();
      });
      builder.addEventListener('submit', async event => {
        const form = event.target.closest('[data-engine-form]');
        if (!form) return;
        event.preventDefault();
        const submit = form.querySelector('[data-engine-submit]');
        if (submit.disabled) return;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        const error = form.querySelector('[data-engine-error]');
        error.hidden = true;
        const items = [{id:form.querySelector('input[name="items[0][id]"]').value,quantity:1}];
        if (form.querySelector('[data-engine-accessory]').checked) items.push({id:form.querySelector('input[name="items[1][id]"]').value,quantity:1});
        try {
          const response = await fetch(builder.dataset.cartAddUrl + '.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || builder.dataset.errorText);
          window.location.assign(builder.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || builder.dataset.errorText;
          error.hidden = false;
          submit.disabled = false;
        } finally { submit.removeAttribute('aria-busy'); }
      });
      const initialParams = new URL(window.location.href).searchParams;
      const initialChoice = content.querySelector('[data-engine-accessory]');
      if (initialChoice && !initialChoice.disabled) initialChoice.checked = initialParams.get('tillbehor') !== '0';
      const selectedClass = initialParams.get('klass');
      const radio = [...builder.querySelectorAll('[data-engine-class]')].find(input => input.value === selectedClass);
      if (radio) {radio.checked = true;radio.dispatchEvent(new Event('change', {bubbles:true}));}
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
